import React, { useEffect, useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { WidgetSize } from '../../../types/Dashboard';
import { useAuth } from '../../../contexts/AuthContext';
import { firebaseService } from '../../../services/firebaseService';

interface AreaChartWidgetProps {
  config: {
    chartType?: string;
    dateRange?: '7d' | '30d' | '90d' | '180d' | '365d' | 'custom';
    startDate?: string;
    endDate?: string;
  };
  size: WidgetSize;
}

const AreaChartWidget: React.FC<AreaChartWidgetProps> = ({ config, size }) => {
  const { userProfile } = useAuth();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');

  useEffect(() => {
    loadChartData();
  }, [config.chartType, config.dateRange, config.startDate, config.endDate, userProfile?.empresaCnpj]);

  const loadChartData = async () => {
    if (!userProfile?.empresaCnpj || !config.chartType) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const charts = await firebaseService.getDashboardCharts(userProfile.empresaCnpj);

      switch (config.chartType) {
        case 'evolucao-alunos':
          setTitle('Evolução de Alunos');
          setData(charts.chartData || []);
          break;
        case 'progresso-alunos':
          setTitle('Progresso de Alunos');
          // Implementar lógica de progresso
          setData([]);
          break;
        default:
          setTitle('Gráfico de Área');
          setData(charts.chartData || []);
      }
    } catch (error) {
      console.error('Erro ao carregar dados do gráfico:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-300"></div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col min-h-0">
      {title && (
        <h3 className="text-sm font-semibold text-gray-900 mb-4 flex-shrink-0">{title}</h3>
      )}
      <div className="flex-1 min-h-0">
        <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="mes" stroke="#6b7280" fontSize={12} />
          <YAxis stroke="#6b7280" fontSize={12} />
          <Tooltip
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }}
          />
          <Area
            type="monotone"
            dataKey="alunos"
            stroke="#3b82f6"
            fill="#3b82f6"
            fillOpacity={0.3}
            name="Alunos"
          />
        </AreaChart>
      </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AreaChartWidget;

